export const getEntidadeSelector = state => state.entidade.entidade;

export const getEntidadeIdSelector = state => state.entidade.entidade?.id;
